import "./polyfills";

import * as Pages from "./pages";
import * as Rooms from "./rooms";
import "./vendors";
import GameLogic from "./core/game-logic";


/* Static Page */
import * as StaticScripts from "./static";

/* Entry script */
window.screenCalculationFunc = null;

//Rooms object
Object.keys(Rooms).forEach((key) => new Rooms[key]());

//Pages object
Object.keys(Pages).forEach((key) => Pages[key]());

//Static Scripts
Object.keys(StaticScripts).forEach((key) => StaticScripts[key]());

//Start game init
GameLogic.init();
